export default (editor, opts = {}) => {
  const bm = editor.BlockManager;
  const style = `<style>
  .item {
    height: 200px;
    margin: 50px auto;
    padding-top: 75px;
    text-align: center;
  }
  </style>
  `;
  bm.add(opts.name, {
    label: `
    <div style="display: flex; justify-content: center">
    <svg class="icon-lofty-component-block" width="50px" height="50px" viewBox="0 0 512 512" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" stroke="none">
<path d="M466 4549 c-62 -15 -153 -68 -197 -116 -22 -24 -55 -74 -72 -111
l-32 -67 0 -1696 0 -1695 37 -76 c45 -91 103 -147 196 -191 l67 -32 2096 0
2095 0 76 37 c91 45 147 103 191 196 l32 67 0 1695 0 1695 -32 67 c-44 93
-100 151 -191 196 l-76 37 -2075 2 c-1231 0 -2092 -3 -2115 -8z m4168 -161
c55 -16 138 -99 154 -154 9 -32 12 -340 12 -1298 l0 -1256 -2240 0 -2240 0 0
1256 c0 958 3 1266 12 1298 15 51 99 137 148 153 53 17 4097 17 4154 1z m166
-3164 c0 -204 -4 -310 -12 -338 -16 -55 -99 -138 -154 -154 -60 -18 -4088 -18
-4148 0 -55 16 -138 99 -154 154 -8 28 -12 134 -12 338 l0 296 2240 0 2240 0
0 -296z"/>
<path d="M3827 3910 c-58 -15 -135 -57 -183 -102 -41 -38 -114 -162 -114 -194
0 -11 -21 -14 -92 -14 -287 0 -577 -98 -814 -273 -189 -140 -369 -376 -449
-590 l-18 -48 -46 88 c-62 119 -120 201 -204 290 -208 219 -489 350 -793 369
-100 7 -102 7 -128 -19 -34 -34 -35 -79 -1 -112 19 -20 34 -25 74 -25 189 0
422 -78 586 -195 71 -51 191 -170 241 -240 47 -66 111 -193 141 -280 27 -81
53 -226 53 -303 0 -43 5 -58 25 -77 31 -32 78 -33 109 -2 20 20 24 37 29 127
20 302 138 563 351 776 222 222 483 336 804 351 114 5 132 4 132 -9 0 -8 16
-47 35 -85 43 -86 103 -144 193 -186 61 -29 76 -32 162 -32 86 0 101 3 162 32
93 44 151 100 196 191 35 72 37 81 37 172 0 91 -2 100 -37 172 -68 136 -188
217 -336 224 -42 2 -94 -1 -115 -6z m167 -162 c86 -26 166 -136 166 -228 0
-124 -116 -240 -240 -240 -63 0 -114 23 -165 75 -102 101 -102 229 0 330 70
71 145 90 239 63z"/>
<path d="M3282 1347 c-43 -13 -116 -78 -132 -117 l-12 -30 -1265 0 -1264 0
-24 -25 c-33 -32 -33 -78 0 -110 l24 -25 1264 0 1265 0 12 -30 c28 -68 129
-130 210 -130 81 0 182 62 210 130 l12 30 465 0 464 0 24 25 c16 15 25 36 25
55 0 19 -9 40 -25 55 l-24 25 -464 0 -465 0 -12 30 c-17 42 -90 104 -138 118
-47 14 -105 14 -150 -1z m133 -172 c50 -49 15 -135 -55 -135 -41 0 -80 39 -80
80 0 41 39 80 80 80 19 0 40 -9 55 -25z"/>
</g>
    </svg>
    </div>
    <div class="gjs-block-label">
      ${opts.labelScroll}
    </div> 
    `,
    category: opts.category,
    attributes: {title: 'Animated Background.', id: 'component-animated-background-container-lofty-editor'},
    disable: opts.isDisabled,
    content: `
      <div
        data-gjs-slugLofty="animatedBackgroundContainer"
        data-gjs-name="Fondo con Particulas"
        data-gjs-resizable="{bc: 1}"
        style="min-height: 100px; padding: 10px"
      >
        <span>${opts.defText}</span>
      </div>
    ${style}`,
  });
};
